import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Button = forwardRef((props, reference) => {
    const {
        dataTourAllowTnteraction,
        dataTourStep,
        id,
        dataTestId,
        className,
        text,
        hasPopup,
        isExpanded,
        isDisabled,
        onClick,
    } = props;
    return (
        <button
            data-tour-allow-interaction={dataTourAllowTnteraction}
            data-tour-step={dataTourStep}
            type="button"
            id={id}
            data-test-id={dataTestId}
            className={className}
            aria-haspopup={hasPopup}
            aria-expanded={isExpanded}
            disabled={isDisabled}
            ref={reference}
            onClick={onClick}
        >
            {text}
        </button>
    );
});

Button.defaultProps = {
    id: null,
    dataTestId: '',
    className: '',
    text: '',
    hasPopup: false,
    isExpanded: false,
    isDisabled: false,
    onClick: () => {},
    dataTourStep: '',
    dataTourAllowTnteraction: false,
};

Button.propTypes = {
    id: PropTypes.string,
    dataTestId: PropTypes.string,
    className: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
    hasPopup: PropTypes.bool,
    isExpanded: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
    dataTourStep: PropTypes.string,
    dataTourAllowTnteraction: PropTypes.bool,
};

export default Button;
